import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import React from "react";
import { Widget } from "../../../components/widget";

export const WidgetList = ({ loading, stats }) => {
  const { t } = useTranslation();
  const amount = (e) => {
    const format = new Intl.NumberFormat("en-US").format(e);
    if (format.indexOf(".") > 0) {
      return format.substr(0, format.indexOf("."));
    } else {
      return new Intl.NumberFormat("en-US").format(e);
    }
  };
  return (
    <div>
      <div className="widget-list-container">
        <Typography
          variant="h4"
          style={{ marginBottom: 20, marginLeft: "3.25vw" }}
        >
          {t("text_quick_stats")}
        </Typography>
        <div>
          <div className="widget-list">
            {stats.map(({ name, value, id, top, maxWidth }, i) => {
              return (
                <Widget
                  name={t(name)}
                  value={value === "-" ? value : amount(value)}
                  key={id}
                  top={value === "-" ? "" : top}
                  loading={loading}
                  maxWidth={maxWidth}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
